import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const SUB_ROLES = [
  { value: "acquisitions", label: "Acquisitions" },
  { value: "dispositions", label: "Dispositions" },
  { value: "cold_caller", label: "Cold Caller" },
  { value: "lead_manager", label: "Lead Manager" },
  { value: "transaction_coordinator", label: "Transaction Coordinator" },
];

export const subRoleLabel = (v) => SUB_ROLES.find((r) => r.value === v)?.label || "Unassigned";

export const KPI_FIELDS = [
  { key: "calls", label: "Calls" },
  { key: "contacts", label: "Contacts" },
  { key: "leads", label: "Leads" },
  { key: "appointments", label: "Appointments" },
  { key: "offers", label: "Offers" },
  { key: "contracts", label: "Contracts" },
  { key: "deals_closed", label: "Deals Closed" },
];
